export const INVOICE_VENDOR_NAME_INFO_TYPE_ID =
  '0195209d-f114-8576-0e08-d9a7e9143340'
export const RECEIPT_VENDOR_NAME_INFO_TYPE_ID =
  '0192d9d9-e8f9-d21a-3e31-8c795804cb46'

export const VENDOR_NAME_INFO_TYPES_IDS = [
  INVOICE_VENDOR_NAME_INFO_TYPE_ID,
  RECEIPT_VENDOR_NAME_INFO_TYPE_ID,
]

export const INVOICE_REMIT_ADDRESS_INFO_TYPE_ID =
  '0195251a-5c12-792c-65e2-13db720f28ce'

export const ENTRATA_VENDOR_HEADER_ADDRESS_INFO_TYPE_IDS = [
  '0193e139-4b98-1e82-6c68-9eed578223f1', // prod
  '01940a48-4729-7c91-05f6-642a4e453081', // dev
]

export const INVOICE_VENDOR_ADDRESS_INFO_TYPE_ID =
  '0195251a-5bfd-5532-b35c-288599bd0a97'
export const RECEIPT_VENDOR_ADDRESS_INFO_TYPE_ID =
  '0194568a-86d4-7651-c0b2-1e13c8dad948'

export const VENDOR_ADDRESS_INFO_TYPES_IDS = [
  INVOICE_VENDOR_ADDRESS_INFO_TYPE_ID,
  RECEIPT_VENDOR_ADDRESS_INFO_TYPE_ID,
]

export const ENTRATA_VENDOR_NAME_INFO_TYPE_IDS = [
  '01979df5-f25c-12f9-0e49-27b52b003ead', // prod
  '01975c1b-d908-10fd-505c-3c7c64f7ac66', // dev
]

export const ENTRATA_VENDOR_ADDRESS_INFO_TYPE_IDS = [
  '0192d9d9-f1b4-c83e-1cd7-efba40059f10', // prod
  '0192de7b-6493-0a13-c44d-f95b9d612f7c', // dev
]

export const RECEIPT_VENDOR_INFO_TYPE_ID =
  '01985d8c-1f0d-f1ca-47b4-51221bbe3ed7'
export const INVOICE_VENDOR_INFO_TYPE_ID =
  '0197c775-0c7b-d58e-0a2b-f1f29471c106'

export const VENDOR_INFO_TYPE_IDS = [
  INVOICE_VENDOR_INFO_TYPE_ID,
  RECEIPT_VENDOR_INFO_TYPE_ID,
]

export const INVOICE_PAYMENT_METHOD_INFO_TYPE_ID =
  '01985d85-608c-85ca-a9ef-ef80c8b6c4e1'
export const RECEIPT_PAYMENT_METHOD_INFO_TYPE_ID =
  '01985d87-4fb1-e8df-1e08-2d17151ef1b4'

export const PAYMENT_METHOD_INFO_TYPES_IDS = [
  INVOICE_PAYMENT_METHOD_INFO_TYPE_ID,
  RECEIPT_PAYMENT_METHOD_INFO_TYPE_ID,
]

export const INVOICE_GL_ACCOUNT_INFO_TYPE_ID =
  '01985d81-5d57-1e2c-7430-2d827c8d84f9'
export const RECEIPT_GL_ACCOUNT_INFO_TYPE_ID =
  '0192d9d9-e96c-a0b9-1c22-98eaa403b099'

export const GL_ACCOUNT_INFO_TYPES_IDS = [
  INVOICE_GL_ACCOUNT_INFO_TYPE_ID,
  RECEIPT_GL_ACCOUNT_INFO_TYPE_ID,
]

export const PURCHASE_ORDER_INFO_TYPE_ID =
  '019c9212-cc32-a270-6881-914f5b0755bb'

export const PURCHASE_ORDER_NUMBER_INFO_TYPE_ID =
  '0195209c-e778-e437-a2f7-79b1802d8b29'
export const INVOICE_NUMBER_INFO_TYPE_ID =
  '0195209b-8a8d-7a9e-25d7-98f806ada497'
export const INVOICE_DATE_INFO_TYPE_ID = '0195251a-5c4f-29b8-3e5a-87736dac8d23'
export const DUE_DATE_INFO_TYPE_ID = '0195251a-5c58-0919-d4ba-08919af79b58'

export const INVOICE_TOTAL_INFO_TYPE_ID = '0195251a-5c74-f610-da17-f779bab619df'

export const INVOICE_LINE_ITEM_TOTAL_INFO_TYPE_ID =
  '01979f23-6d84-3c73-2417-8e599e723bfe'
export const INVOICE_LINE_ITEM_AMOUNT_INFO_TYPE_ID =
  '01952526-65fe-9b8d-7589-958a4967a84b'
export const INVOICE_LINE_ITEM_DESCRIPTION_INFO_TYPE_ID =
  '019520a6-8cac-debf-5c4d-fca3fc46cf07'
export const LINE_ITEM_QUANTITY_SHIPPED_INFO_TYPE_ID =
  '01952526-6630-af1b-03eb-bd0825853a2a'
export const LINE_ITEM_QUANTITY_ORDERED_INFO_TYPE_ID =
  '01952526-6626-f983-5453-787f0f178549'
export const LINE_ITEM_QUANTITY_REMAINING_INFO_TYPE_ID =
  '01952526-6639-92fd-8f50-c130d6aa7a41'
export const LINE_ITEM_RATE_INFO_TYPE_ID =
  '01952526-6644-afab-7c72-46bb624c6176'

export const LINE_ITEM_JOB_INFO_TYPE_ID = '019c595a-28d0-5c95-b614-c7ea95b39571'
export const LINE_ITEM_PHASE_INFO_TYPE_ID =
  '019c71e7-a361-e5d0-3d06-5442980246c5'
export const LINE_ITEM_COST_TYPE_INFO_TYPE_ID =
  '019de549-86af-9c95-9f21-924249b919fb'

export const LINE_ITEM_INFO_TYPES_IDS = [
  INVOICE_LINE_ITEM_TOTAL_INFO_TYPE_ID,
  INVOICE_LINE_ITEM_DESCRIPTION_INFO_TYPE_ID,
  LINE_ITEM_QUANTITY_SHIPPED_INFO_TYPE_ID,
  LINE_ITEM_RATE_INFO_TYPE_ID,
]
